/* global stepsTemplates, verificationAttemptsExhaustedRoute, funnelImpressionUrl, funnelSlug, gtag, toastr, trackComplete, ga4TrackingID, tnsRnTracking, requiresRecaptchaV3, recaptchaV3Sitekey, grecaptcha, overridePhoneValidationButtonDisable, overrideEmailValidationButtonDisable, landingJobId, recommenderSessionLimit, contactRoute */
import AddMore from '@components/buttons/add-more';
import CountUp from 'countup.js';
import { buttonLoading } from '@common/ajax-helpers';
import { backendErrorHandler, errorHandler, slugifyError } from '@common/errors';
import { success } from '@common/alert';
import { checkDuplicatePhone, checkDuplicateEmail, prefillCurrentState } from '@common/verify-duplicate-leads';
import { scrollToElement, scrollToTop } from '@common/scroll';
import TagManager from '../common/tagmanager';
import JobList from '@components/job-recommender/job-list';
import LicensesSearch from '@common/licenses';
import SpecialtiesSearch from '@common/specialties';
import OneTimeCodeVerification from '@components/one-time-code/verification';

/**
 * @typedef FunnelImpressionFailureResponse
 * @type {object}
 * @property {object} responseJSON - jqXHR thing...
 * @property {string[]} responseJSON.errors
 */

/**
 * @typedef MatchingClientSummary
 * @type {object}
 * @property {int} id
 * @property {string} logo
 * @property {string} logo_url
 * @property {string} name
 * @property {string} profile
 */

/**
 * @typedef ConversionData
 * @type {object}
 * @property {string} sha256_email_address
 * @property {string} sha256_phone_number
 * @property {string} address_sha256_first_name
 * @property {string} address_sha256_last_name
 * @property {string} address_street
 * @property {string} address_city
 * @property {string} address_region
 * @property {string} address_postal_code
 * @property {string} address_country
 */

/**
 * @typedef VerificationData
 * @type {object}
 * @property {string} sent_to
 */

/**
 * @typedef ApplyStepData
 * @type {object}
 * @property {array} chosenClientIds - Clients which the candidate has chosen to apply to.
 * @property {int} curStep - The current funnel step.
 * @property {string} funnelSlug
 * @property {string} funnelType
 * @property {boolean} hasMoreRecommendedJobs
 * @property {boolean} isJobApp
 * @property {boolean} isPremium
 * @property {boolean} leadCreated
 * @property {int|null} lead_id
 * @property {MatchingClientSummary[]} matchingClientSummaries
 * @property {boolean|mixed} needsRedirect
 * @property {array} premiumClientCards
 * @property {boolean} qualifiedForJob
 * @property {string|null} nextCursor - The "next" cursor for job recommender paging
 * @property {string[]} recommendedJobs - Markup for the recommended jobs
 * @property {string} emailLoginLink - Login link for TDC/TNN candidates
 * @property {string} recommendationService - Which recommendation service to use for this funnel
 * @property {boolean} [fireTnsRnEvent]
 * @property {string} [general] - A redirect message if the candidate has already completed their application
 * @property {string} [redirectTo] - A redirect URL used if the candidate has already completed their application
 * @property {string} [license]
 * @property {VerificationData} [verification]
 * @property {int} [licenseId]
 * @property {int} [specialtyId]
 * @property {object} [preferredDestinations]
 * @property {object} [specialtiesForLicense]
 * @property {ConversionData} [conversionData]
 */
$(document).ready(() => {
    if (document.getElementById('apply-container')) {
        ////////////////////////////////////////////////////////////////////////////////////////////////////
        // Constants
        ////////////////////////////////////////////////////////////////////////////////////////////////////
        const RECOMMENDER_ON = 'on';
        const RECOMMENDER_OFF = 'off';
        const RECOMMENDER_PROMOTED_ONLY = 'p-only';
        const RECOMMENDER_NONPROMOTED_ONLY = 'np-only';

        const recommenderInternalSource = 'funnel-recommender';
        const $body = $('body');
        const $phone = $('#phone');
        const $first = $('#first');
        const $last = $('#last');
        const $email = $('#email');
        const $step = $('#step');
        const $tcpaDisclosure = $('.tcpa-disclosure');
        const $recommender = $('#job-recommender-step');
        const recommenderStep = parseInt($recommender.data('step') || 0);
        const $verification = $('#component__one_time_code__verification');
        const verificationStep = parseInt($verification.data('step') || 0);
        const tcpaStep = parseInt($tcpaDisclosure.data('step'));
        const $tcpaStepContainer = $(`#apply-step-content-${tcpaStep}`);
        const $companyChoiceSubmit = $('#company_choice_submit');

        const $ovrSpecialtyField = $('#override-specialty');
        const $ovrLicenseField = $('#override-license');

        ////////////////////////////////////////////////////////////////////////////////////////////////////
        // Functions
        ////////////////////////////////////////////////////////////////////////////////////////////////////
        const getCurStep = () => parseInt($step.val(), 10);
        const getTotalSteps = () => parseInt($('#total-steps').val(), 10);
        const getStepContent = (step) => $(`#apply-step-content-${step}`);
        const getCurStepContent = () => getStepContent(getCurStep());

        const getRecommenderControlValue = () => {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get('recommender');
        };

        /**
         * @param {number} step
         */
        const triggerGaPageview = (step) => {
            if (ga4TrackingID) {
                gtag('config', ga4TrackingID, {
                    // eslint-disable-next-line camelcase
                    page_location: '/step-' + step + '-complete',
                });
            } else {
                // eslint-disable-next-line no-console
                console.log(`GA4 is disabled. Would have sent page view for '/step-${step}-complete'`);
            }
        };

        const previousPage = () => {
            const curStep = getCurStep();

            $('#apply-companies .list-group').html('');

            // eslint-disable-next-line no-use-before-define
            changePage(curStep - 1);
        };

        const nextPage = () => {
            const curStep = getCurStep();
            triggerGaPageview(curStep);

            // eslint-disable-next-line no-use-before-define
            changePage(curStep + 1);
        };

        const disableButtons = () => {
            if (document.getElementById('landing-form')) {
                $('#landing-form').find('.btn-next')
                    .prop('disabled', true);
            } else {
                const $curStepContent = getCurStepContent();

                $curStepContent.find('.btn-next, .btn-previous')
                    .prop('disabled', true);
            }
        };

        const enableButtons = () => {
            if (document.getElementById('landing-form')) {
                $('#landing-form').find('.btn-next')
                    .prop('disabled', false);
            } else {
                const $curStepContent = getCurStepContent();

                $curStepContent.find('.btn-next, .btn-previous')
                    .prop('disabled', false);
            }
        };

        /**
         * Determine if the current (or provided) step is the verification step.
         * @param {int|null} [step]
         * @returns {boolean}
         */
        const isVerificationStep = (step) => {
            return $verification.length > 0 && step === verificationStep;
        };

        /**
         * Determine if the current (or provided) step is the job recommender step.
         * @param {int|null} [step]
         * @returns {boolean}
         */
        const isRecommenderStep = (step) => {
            return $recommender.length > 0 && step === recommenderStep;
        };

        /**
         * @param {array|null} recommendedJobs
         * @param {boolean} premium
         * @returns {boolean}
         */
        const showJobRecommender = (recommendedJobs, premium, recommenderControl) => {
            return recommendedJobs && recommendedJobs.length > 0 && !premium && recommenderControl !== RECOMMENDER_OFF;
        };

        if ($tcpaStepContainer.length && $tcpaStepContainer.is(':visible')) {
            if (parseInt($step.val()) === tcpaStep) {
                $tcpaDisclosure.show();
            } else {
                $tcpaDisclosure.hide();
            }
        }

        /**
         * Override wantsPromotedJobs and wantsNonPromotedJobs based on the recommender control.
         * @param {string} recommenderControl
         * @param {boolean} defaultPromoted
         * @param {boolean} defaultNonPromoted
         * @returns {{ wantsPromotedJobs: boolean, wantsNonPromotedJobs: boolean }}
         */
        const getRecommenderOverrides = (recommenderControl, defaultPromoted, defaultNonPromoted) => {
            switch (recommenderControl) {
                case RECOMMENDER_ON:
                    return {
                        wantsPromotedJobs: true,
                        wantsNonPromotedJobs: true,
                    };
                case RECOMMENDER_NONPROMOTED_ONLY:
                    return {
                        wantsPromotedJobs: false,
                        wantsNonPromotedJobs: true,
                    };
                case RECOMMENDER_PROMOTED_ONLY:
                    return {
                        wantsPromotedJobs: true,
                        wantsNonPromotedJobs: false,
                    };
                default:
                    return {
                        wantsPromotedJobs: defaultPromoted,
                        wantsNonPromotedJobs: defaultNonPromoted,
                    };
            }
        };

        ////////////////////////////////////////////////////////////////////////////////////////////////////
        // ATJ
        ////////////////////////////////////////////////////////////////////////////////////////////////////

        $('input[name="acc_vio"]').on('change', function() {
            const violationSection = $('.violations-section');

            if ($(this).val() === '1') {
                $('select[name="lead[accidents]"]').val(null).trigger('change');
                $('select[name="lead[moving_violations]"]').val(null).trigger('change');
                violationSection.show();
                violationSection.find('select').attr('required', true);
            } else {
                $('select[name="lead[accidents]"]').val(null).trigger('change');
                $('select[name="lead[moving_violations]"]').val(null).trigger('change');
                violationSection.hide();
                violationSection.find('select').attr('required', false);
            }
        });

        $('input[name="sus_dui"]').on('change', function() {
            const duiSection = $('.dui-section');
            if ($(this).val() === '1') {
                duiSection.show();
            } else {
                $('select[name="lead[suspended]"]').val(null).trigger('change');
                $('select[name="lead[dui]"]').val(null).trigger('change');
                duiSection.hide();
            }
        });

        if ($('input:radio[name="acc_vio"]:checked').val() === '1') {
            $('.violations-section').show();
        }

        if ($('input:radio[name="sus_dui"]:checked').val() === '1') {
            $('.dui-section').show();
        }

        ////////////////////////////////////////////////////////////////////////////////////////////////////
        // TDC
        ////////////////////////////////////////////////////////////////////////////////////////////////////

        const manageTdcLayout = () => {
            if ($('.tdc-topbar').length) {
                if (getCurStep() === 1) {
                    $('.tdc-tagline>h2').removeClass('d-none d-sm-block');
                } else {
                    $('main > container').css('margin-top', '2rem');
                    $('.tdc-tagline>h2').addClass('d-none d-sm-block');
                }
            }
        };
        manageTdcLayout();

        ////////////////////////////////////////////////////////////////////////////////////////////////////
        // TNN
        ////////////////////////////////////////////////////////////////////////////////////////////////////

        const manageTnnLayout = () => {
            if ($('.tnn-topbar').length) {
                if (getCurStep() === 1) {
                    $('.tnn-hero-content').removeClass('d-none');
                    $('main').removeClass('tnn-bg');
                } else {
                    $('#mobile-banner-homepage').addClass('d-none');
                    $('.tnn-hero-content').addClass('d-none');
                    $('#subsection-details').addClass('d-none');
                    $('#subheadline').addClass('d-none');
                    $('#fluid-apply-content').removeClass('hero-tnn');
                    $('.logo-tnn').removeClass('d-sm-block');
                    $('main').addClass('tnn-bg');
                    $('#hero-desktop').addClass('h-100');
                    $('#landing-form').removeClass().addClass('col-12');
                    $('#landing-headline').addClass('d-none');
                    $('#header-content').removeClass('header-content');
                }

                $('#dream-destination-callout-carousel').slick({
                    infinite: false,
                    speed: 500,
                    fade: false,
                    cssEase: 'linear',
                    slidesToShow: 3,
                    centerMode: true,
                    arrows: false,
                    slidesToScroll: 1,
                    autoplay: false,
                    responsive:
                        [
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: 1,
                                    centerMode: true,
                                },
                            },
                            {
                                breakpoint: 480,
                                settings: {
                                    slidesToShow: 1,
                                    centerMode: true,
                                },
                            },
                        ],
                });

                $('.dream-destination-callout-prev').click(function() {
                    $('#dream-destination-callout-carousel').slick('slickPrev');
                });

                $('.dream-destination-callout-next').click(function() {
                    $('#dream-destination-callout-carousel').slick('slickNext');
                });
            }
        };
        manageTnnLayout();
        ////////////////////////////////////////////////////////////////////////////////////////////////////
        // TNS
        ////////////////////////////////////////////////////////////////////////////////////////////////////

        if ($('.cobrand-tns').length) {
            $('main').addClass('tns-tnn-bg');
            $('body').addClass('tns-tnn-brand');
        }

        $('input[name="lead[license_investigated]"]').on('change', function() {
            const $details = $('textarea[name="lead[license_investigation_details]"]');
            const $conditional = $details.closest('.conditional');

            if ($(this).val() === '1') {
                $conditional.show();
            } else {
                $conditional.hide();
                $details.val('').trigger('change');
            }
        });

        if ($('input[name="lead[license_investigated]"]:checked').val() === '1') {
            $('textarea[name="lead[license_investigation_details]"]')
                .closest('.conditional')
                .show();
        }

        ////////////////////////////////////////////////////////////////////////////////////////////////////
        // LJO
        ////////////////////////////////////////////////////////////////////////////////////////////////////

        $('#locum').on('change', function() {
            const $cbx = $(this);

            // If locum, disable perm.  If not locum, enable perm.
            $('#perm').prop('disabled', $cbx.is(':checked'));
        });

        ////////////////////////////////////////////////////////////////////////////////////////////////////
        // ATN
        ////////////////////////////////////////////////////////////////////////////////////////////////////

        if ($('.cobrand-atc').length) {
            $('body').addClass('atc-atn-brand');
        }

        ////////////////////////////////////////////////////////////////////////////////////////////////////
        // GENERAL
        ////////////////////////////////////////////////////////////////////////////////////////////////////

        $(window).on('beforeunload', () => null);

        // Trigger a funnel impression
        $.post(funnelImpressionUrl, { slug: funnelSlug }).fail(
            /**
             * @param {FunnelImpressionFailureResponse} data
             */
            (data) => {
                if (data.responseJSON && data.responseJSON.errors) {
                    $.each(data.responseJSON.errors, (index, err) => {
                        /* eslint-disable no-console */
                        console.error(err.detail);
                        /* eslint-enable no-console */
                    });
                }
            },
        );

        const $preferredDestinations = $('select[name="lead[preferred_destinations][]"]');

        if ($preferredDestinations) {
            $preferredDestinations.select2({
                minimumInputLength: 2,
                ajax: {
                    url: $preferredDestinations.data('source'),
                    dataType: 'json',
                    delay: 500,
                },
                placeholder: 'City, State, or Zip Code',
            });
        }

        $body.on('change', '.employer-current-employer', function() {
            const $toggle = $(this);
            const $date = $toggle
                .closest('.repeated-info')
                .find('.employer-end-date');
            const isCurEmployer = $toggle.prop('checked');

            $date.prop('disabled', isCurEmployer);

            if (isCurEmployer) {
                $date.val('');
            }
        });

        const setPassword = ($btn) => {
            const $form = $('#set-password-form');

            return buttonLoading($btn, $.ajax({
                method: $form.prop('method'),
                url: $form.prop('action'),
                data: $form.serialize(),
            }));
        };

        const handleSetPassword = ($btn) => {
            const $modal = $('#set-password-modal');

            return setPassword($btn)
                .then((res) => {
                    $('#quick-setup-password').hide();
                    $modal.modal('hide');

                    return success(res.message);
                })
                .catch(errorHandler);
        };

        const detachBeforeUnload = () => {
            $(window).off('beforeunload');
            return true;
        };

        $('#set-password-modal').on('shown.bs.modal', function() {
            const $email = $('#email');
            if ($email.val()) {
                $('#set-password-email').val($email.val());
            }

            $('#set-password-password').select();
        });

        $('#set-password-form').on('submit', function(event) {
            event.preventDefault();

            const $btn = $('#set-password-profile');

            handleSetPassword($btn)
                .then(() => {
                    $(window).off('beforeunload');
                    location.href = $btn.data('source');
                });
        });

        $('#admin_login_form').on('submit', detachBeforeUnload);
        $('#forgot_password_link').on('click', detachBeforeUnload);

        $('#set-password-return').on('click', function() {
            const $form = $('#set-password-form');

            if (!$form.parsley().validate()) {
                return false;
            }

            handleSetPassword($(this));
        });

        $body.on('change', '#phone, #first, #last', checkDuplicatePhone.bind(this, $phone, $first, $last));
        $body.on('change', '#email', checkDuplicateEmail.bind(this, $email));

        //Ajax login setup
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('#loginModal meta[name="csrf-token"]').attr('content'),
            },
        });

        //Validation
        let parsley = $('#apply-form').parsley({
            trigger: 'focusout',
        });

        const companyCount = (count) => {
            const $companyCountMessage = $('.company-count-message');

            if (!$companyCountMessage.length) {
                return;
            }

            if (count === undefined) {
                count = parseInt($('#company-count').text(), 10);
            }

            if (count > 0) {
                $companyCountMessage.show();

                const countUp = new CountUp(
                    $('#company-count')[0],
                    0,
                    count,
                    0,
                    2.5,
                    {},
                );

                if (!countUp.error) {
                    countUp.start();
                }
            } else {
                $companyCountMessage.hide();
            }
        };

        /**
         *
         * @param {MatchingClientSummary[]} companies
         * @param {int} step
         */
        const addCompanies = (companies, step) => {
            $('#apply-companies .list-group').html('');

            companies.forEach(function(company, index) {
                let html =
                    `<div class="apply-company list-group-item list-group-item-action flex-column align-items-start">
                        <div class="row">
                            <div class="col-3 col-md-2 align-self-center">
                                <img alt="${company.name} logo" src="${company.logo_url}" />
                            </div>
                            <div class="col-7 col-md-9 name">
                                <div class="d-flex w-100 justify-content-between">
                                    <h5 class="mb-1">${company.name}</h5>
                                </div>
                                <p class="d-none d-md-block mb-1">${company.profile}</p>
                            </div>
                            <div class="col-2 col-md-1 align-self-center text-center">
                                <div class="custom-control custom-checkbox">
                                    <input checked name="apply_companies[]" class="custom-control-input company-checkbox desktop-checkbox" id="company-check-${company.id}" value="${company.id}" type="checkbox" ${index === 0 ? ' data-parsley-group="' + step + '" data-parsley-errors-container="#company_choice_errors" data-parsley-error-message="You must select at least 1 company." required' : ''}>
                                    <label class="custom-control-label" for="company-check-${company.id}"></label>
                                </div>
                            </div>
                            <div class="col-12 d-block d-md-none">
                                <p>${company.profile}</p>
                            </div>
                        </div>
                    </div>`;
                $('#apply-companies .list-group').append(html);
                $('.select-companies-toggle').text('Deselect All Companies');
            });
        };

        /**
         *
         * @param {string[]} cards
         */
        const addPremiumClients = (cards) => {
            const $container = $('#premium-clients');

            Array.from(new Set(cards))
                .forEach((card) => {
                    $container.append(card);
                });
        };

        let queue = $.Deferred().resolve().promise();

        /**
         * @param {object|null} errors
         */
        const showErrors = (errors) => {
            parsley.reset();

            if (!errors || typeof errors !== 'object') {
                return;
            }

            if (errors?.errors) {
                // Back-end validator errors
                backendErrorHandler(errors.errors, $('#apply-form'));
            } else {
                Object.keys(errors).forEach((fieldName) => {
                    if (fieldName === 'general') {
                        toastr.error(errors[fieldName]);
                    } else if (fieldName === 'apply_companies') {
                        scrollToTop();
                        toastr.error(errors[fieldName]);
                    } else {
                        const $field = $(`[name="${fieldName}"]`).parsley();
                        if (Array.isArray(errors[fieldName])) {
                            errors[fieldName].forEach((error) => {
                                $field.addError(slugifyError(error), { message: error });

                                if (fieldName === 'email'
                                    && error === 'The email has already been taken.'
                                ) {
                                    $('#loginModal').modal('show');
                                    $('#loginModal #login-email').val($('#email').val());
                                }
                            });
                        }
                    }
                });
            }
        };

        $('input').on('input', function() {
            $(this).parsley().reset();
        });

        $('select').on('change', function() {
            $(this).parsley().reset();
        });

        /**
         * @param {int} step - The current step number
         * @param {'forward'|'backward'} direction - In which direction should the apply funnel step from the current step number
         */
        let triggerStep = (step, direction) => {
            parsley.reset();
            $('.apply-message').html('');
            disableButtons();

            if (direction === 'forward') {
                triggerGaPageview(step);

                const appData = $(`#apply-form fieldset#step-${step} :input`).serializeArray();
                appData.push({ name: 'step', value: step });
                appData.push({ name: 'total-steps', value: getTotalSteps() });
                appData.push({ name: 'source', value: $('#apply-form #source').val() });
                appData.push({ name: 'recommender', value: getRecommenderControlValue() });

                const $jobId = $('#apply-form #job_id');
                if ($jobId) {
                    appData.push({ name: 'lead[job_id]', value: $jobId.val() });
                }

                if (isVerificationStep(step)) {
                    appData.push({ name: 'verification_code', value: $('#verification_code__all').val() });
                }

                if (landingJobId != null) {
                    appData.push({ name: 'landing_job_id', value: landingJobId });
                }

                /**
                 * These following two fields are meant for correcting an issue where the recommender
                 * override functionality is updating a candidate, but then the change is being overwritten
                 * when the user moves to the next step of the funnel.
                 */
                if ($ovrSpecialtyField.length) {
                    appData.push({ name: 'override[specialty]', value: $ovrSpecialtyField.val() });
                }

                if ($ovrLicenseField.length) {
                    appData.push({ name: 'override[license]', value: $ovrLicenseField.val() });
                }

                const urlParams = new URLSearchParams(window.location.search);
                urlParams.forEach((value, key) => {
                    appData.push({ name: key, value: value });
                });

                const duplicate = Object.hasOwnProperty.call(window, 't5DuplicateCheck') ? Boolean(window.t5DuplicateCheck) : false;
                appData.push({ name: 'possible_duplicate', value: duplicate });

                if (requiresRecaptchaV3) {
                    const recaptchaV3Action = `apply_step_${direction}_to_${step}`;
                    return grecaptcha.execute(recaptchaV3Sitekey, { action: recaptchaV3Action }).then(function(token) {
                        appData.push({ name: 'recaptcha_v3_token', value: token });
                        appData.push({ name: 'recaptcha_v3_action', value: recaptchaV3Action });
                        // eslint-disable-next-line no-use-before-define
                        return sendApplyRequest(step, direction, [...appData]);
                    });
                }

                // eslint-disable-next-line no-use-before-define
                return sendApplyRequest(step, direction, [...appData]);
            }

            if (direction === 'back') {
                previousPage();
                if (step === tcpaStep + 1) {
                    $tcpaDisclosure.show();
                } else {
                    $tcpaDisclosure.hide();
                }
            }
        };

        const sendApplyRequest = (step, direction, appData) => {
            return $.post('/apply', appData)
                .then(
                    /**
             * @param {ApplyStepData} data
             */
                    (data) => {
                        if (data.leadCreated) {
                            TagManager.setConversionData(data.conversionData);

                            trackComplete(
                                data.isJobApp,
                                data.matchingClientSummaries.length > 0,
                                data.qualifiedForJob,
                                data.lead_id,
                            );

                            TagManager.leadCreated({
                                hasMatchingClients: data.matchingClientSummaries.length > 0,
                                isDirectApp: data.isDirectApp,
                                isJobApp: data.isJobApp,
                                isPromotedSession: data.isPromotedSession,
                                leadId: data.lead_id,
                                license: data.license,
                                qualifiedForJob: data.qualifiedForJob,
                                utmCampaign: data.utmCampaign,
                                utmMedium: data.utmMedium,
                                utmSource: data.utmSource,
                            });
                        }

                        if (data.emailLoginLink !== '') {
                            $('#email_login_link').attr('href', data.emailLoginLink);
                        }

                        if (Object.prototype.hasOwnProperty.call(data, 'fireTnsRnEvent') && data.fireTnsRnEvent) {
                            tnsRnTracking();
                        }

                        if (data.funnelType === 'landing'
                            && data.needsRedirect
                        ) {
                            $(window).off('beforeunload');
                            location.href = '/apply';
                            return;
                        }

                        if (data.redirectTo) {
                            $(window).off('beforeunload');
                            location.href = data.redirectTo;
                            return;
                        }

                        companyCount(data.matchingClientSummaries.length);

                        const isApplyV1 = $('input[name="submit_to"]').length > 0;
                        const isApplyV2 = $('input[name="choose_companies"]').length > 0;
                        const companySelectModal = $('#companySelectModal');

                        if (isApplyV1) {
                            if ($('input[name="submit_to"]:checked').val() === 'choice'
                                && data.matchingClientSummaries.length > 0
                            ) {
                                if (data.chosenClientIds.length === 0 && step > 1) {
                                    addCompanies(data.matchingClientSummaries, step + 1);
                                    companySelectModal.modal('show');

                                    return;
                                }
                            }
                        } else if (isApplyV2) {
                            if ($('input[name="choose_companies"]:checked').val() === '1'
                                && data.matchingClientSummaries.length > 0
                            ) {
                                addCompanies(data.matchingClientSummaries, step + 1);
                                $('#apply-companies').show();
                            } else {
                                $('#apply-companies').hide();
                            }
                        }

                        if (step === tcpaStep - 1 && direction === 'forward') {
                            $tcpaDisclosure.show();
                        } else {
                            $tcpaDisclosure.hide();
                        }

                        $('.unqualified-message').toggle(data.matchingClientSummaries.length === 0);

                        if (
                            data.isPremium
                            && data.premiumClientCards
                            && data.premiumClientCards.length > 0
                        ) {
                            addPremiumClients(data.premiumClientCards);
                        }

                        if (
                            isRecommenderStep(data.curStep) &&
                            showJobRecommender(data.recommendedJobs, data.isPremium, getRecommenderControlValue())
                        ) {

                            const recommenderControl = getRecommenderControlValue();
                            const { wantsPromotedJobs, wantsNonPromotedJobs } = getRecommenderOverrides(
                                recommenderControl,
                                data.recommenderWantsPromotedJobs,
                                data.recommenderWantsNonPromotedJobs,
                            );

                            const jobList = new JobList({
                                source: recommenderInternalSource,
                                hasMoreRecommendations: data.hasMoreRecommendedJobs,
                                nextCursor: data.nextCursor,
                                recommenderType: data.recommendationService,
                                wantsPromotedJobs: wantsPromotedJobs,
                                wantsNonPromotedJobs: wantsNonPromotedJobs,
                                funnelSlug: data.funnelSlug,
                                sessionLimit: recommenderSessionLimit,
                            });

                            jobList.initFromMarkup(data.recommendedJobs);

                            if (['licenseId', 'specialtyId', 'specialtiesForLicense', 'preferredDestinations'].every((key) => Object.hasOwnProperty.call(data, key))) {
                                // Dispatch this event only if all of these keys exist in the data we recieved
                                document.dispatchEvent(new CustomEvent(
                                    'job-recommender-override:init',
                                    {
                                        bubbles: true,
                                        detail: {
                                            license: data.licenseId,
                                            specialty: data.specialtyId,
                                            specialtyList: data.specialtiesForLicense,
                                            destinations: data.preferredDestinations,
                                        },
                                    },
                                ));
                            }

                            const $unqualifiedBanner = $('#job-recommender-step #unqualified-banner');

                            if (
                                data.isJobApp &&
                                !data.qualifiedForJob &&
                                $unqualifiedBanner.length
                            ) {
                                $unqualifiedBanner.removeClass('d-none');
                            }

                            scrollToTop();
                            changePage(recommenderStep);
                        } else {
                            if (isVerificationStep(data.curStep)) {
                                $('#component__one_time_code__verification__sent_to')
                                    .html(data.verification.sent_to)
                                    .after('.<br>This code will expire in 10 minutes.');
                            }

                            if (getCurStep() !== data.curStep) {
                                /**
                         * We can't just go to nextPage anymore here because there's the possibility that we want to
                         * skip the recommender page, in the case that there are no jobs to recommend.
                         */
                                scrollToTop();
                                changePage(data.curStep);
                            }
                        }

                        if (getCurStep() === getTotalSteps()) {
                            $(window).off('beforeunload');
                        }
                    })
                .fail((e) => {
                    document.dispatchEvent(new CustomEvent('apply:request:error', {
                        bubbles: true,
                        detail: e.responseJSON,
                    }));

                    showErrors(e.responseJSON);
                });
        };

        const changePage = (newStep) => {
            const $curStepContent = getCurStepContent();
            const $newStepContent = getStepContent(newStep);

            const curStepClass = `${stepsTemplates[getCurStep()] || 'default'}-container`;
            const newStepClass = `${stepsTemplates[newStep] || 'default'}-container`;
            const $container = $(`main > .container.${curStepClass}`);
            if ($container) {
                $container.removeClass(curStepClass);
                $container.addClass(newStepClass);
            }

            $('.apply-step-heading').parent().prop('hidden', true);
            $(`.apply-step-heading[data-step=${newStep}]`).parent().prop('hidden', false);
            $step.val(newStep);

            manageTdcLayout();
            manageTnnLayout();
            // This fixes a bug where the Select2 placeholder gets cut off, but
            // only when you hit the funnel on a page that the field isn't on
            // and then navigate to it with Back/Next.
            $newStepContent.find('.select2-search__field').css({
                width: 'auto',
            });

            queue = queue
                .then(() => $curStepContent.fadeOut(200))
                .then(() => {
                    return $newStepContent.fadeIn().promise();
                })
                .then(() => scrollToElement($('.form-wizard')))
                .then(enableButtons);

            return queue;
        };

        $('#resume').on('change', function() {
            const $file = $(this);
            const $upload = $('#upload-resume');
            const data = new FormData();
            data.append('resume', $file[0].files[0]);

            $file.prop('disabled', true);
            $upload.addClass('disabled')
                .text('Uploading Resume...');

            $.ajax({
                url: '/apply/resume/ajax',
                data: data,
                processData: false,
                contentType: false,
                type: 'POST',
            }).then(() => {
                $('.btn-next').trigger('click');
                $upload.text('Resume Uploaded!');
            });
        });

        // next step
        const nextStep = ($btn) => {
            const curStep = getCurStep();
            const isCompanyChoiceSubmit = $btn.attr('id') === 'company_choice_submit';
            let shouldHideCompanySelectModal = false;

            if (isCompanyChoiceSubmit) {
                $companyChoiceSubmit.attr('disabled', true);
                if ($('input[name="apply_companies[]"].desktop-checkbox:checked').length === 0) {
                    // No clients were selected on modal
                    toastr.error('You must select at least one company to submit your application to.');
                    $companyChoiceSubmit.attr('disabled', false);
                    return false;
                } else {
                    shouldHideCompanySelectModal = true;
                }
            }

            if (!parsley.validate(curStep)) {
                if (isCompanyChoiceSubmit) {
                    $companyChoiceSubmit.attr('disabled', false);
                }
                scrollToElement($('.parsley-errors-list.filled').parent());
                document.dispatchEvent(new CustomEvent('apply:next-step:validation-failed'));

                return false;
            }

            document.dispatchEvent(new CustomEvent('apply:next-step:validated'));

            triggerStep(curStep, 'forward')
                .then(() => {
                    if (shouldHideCompanySelectModal) {
                        const companySelectModal = $('#companySelectModal');
                        companySelectModal.modal('hide');
                    }
                })
                .then(() => {
                    if (isCompanyChoiceSubmit) {
                        $companyChoiceSubmit.attr('disabled', false);
                    }
                });
        };

        $(document).on('click', '.btn-next, #company_choice_submit', function(evt) {
            nextStep($(evt.currentTarget));
        });

        // previous step
        $('.btn-previous').on('click', function() {
            const curStep = getCurStep();

            triggerStep(curStep, 'back');
        });

        $body.on('click', '.select-companies-toggle', function(evt) {
            evt.preventDefault();
            if ($(this).hasClass('selected')) {
                $('.company-checkbox').prop('checked', true);
                $(this).text('Deselect All Companies');
                $(this).removeClass('selected');
            } else {
                $('.company-checkbox').prop('checked', false);
                $(this).text('Select All Companies');
                $(this).addClass('selected');
            }
        });

        $body.on('click', '.apply-company', function(evt) {
            if (['INPUT', 'LABEL'].includes(evt.target.tagName)) {
                return;
            }

            const $checkbox = $(this).find('input[type=checkbox]');

            $checkbox.prop('checked', !$checkbox.is(':checked'));
        });

        $(document).ajaxSend((event, jqxhr, settings) => {
            if (settings.url === '/apply') {
                const $curStepContent = getCurStepContent();
                const $btn = $curStepContent.find('.btn-next');

                if (document.getElementById('landing-form')) {
                    disableButtons();
                } else {
                    $btn.prop('disabled', true)
                        .html($btn.data('loading-text'));
                }
            }
        }).ajaxError((event, jqxhr, settings) => {
            if (settings.url === '/apply') {
                if (jqxhr.responseJSON?.redirectTo !== undefined) {
                    $(window).off('beforeunload');
                    location.href = jqxhr.responseJSON.redirectTo;
                }

                const $curStepContent = getCurStepContent();
                const $btn = $curStepContent.find('.btn-next');

                if (document.getElementById('landing-form')) {
                    enableButtons();
                } else {
                    $btn.prop('disabled', false)
                        .html($btn.data('text'));
                }

                if (jqxhr.responseJSON?.exception !== undefined) {
                    return;
                }

                queue = queue.then(() => showErrors(jqxhr.responseJSON));
            }
        });

        $('#companySelectModal').on('hidden.bs.modal', function() {
            const redirectUrl = $(this).data('close-redirect');

            if (redirectUrl) {
                $(window).off('beforeunload');
                location.href = $(this).data('close-redirect');
            }
        });

        const stepForwardOnRecommenderEvent = () => {
            const currentStep = getCurStep();
            // I think this is fine, because "trigger Step" will move to whatever page the backend defines as next, and that should be nextPage.
            nextPage();
            triggerStep(currentStep, 'forward');
            scrollToTop();
        };

        /**
 * When a candidate selects their first job to apply to in the job recommender, show a toast message.
 * @listens JobList#job-recommender:list:selection-changed
 */
        $(document).one('job-recommender:list:selection-changed', function() {
            toastr.success('Don\'t forget to click the Apply button to send your job applications.');
        });

        /**
 * Listen for a candidate telling us that they would like to skip the recommender step.
 */
        $(document).one('job-recommender:apply-bar:skip', stepForwardOnRecommenderEvent);

        /**
 * Listen for the no recommendations event and move on.
 */
        // TODO: Check this logic out and make sure it works!!!!!!!
        $(document).one('job-recommender:list:recommendations-unavailable', stepForwardOnRecommenderEvent);

        /**
 * When a candidate clicks the "Apply to selected jobs" button in the recommender, move them along.
 */
        $(document).one('job-recommender:apply-success', function() {
            stepForwardOnRecommenderEvent();

            $(document).off(
                'job-recommender:list:recommendations-unavailable job-recommender:apply-bar:skip',
                stepForwardOnRecommenderEvent,
            );

            toastr.success('Your applications have been submitted.');
        });

        /**
 * If we load the page already on the recommender step, we need to initialize it right away.
 * This is the case on the Landing Page for healthcare brands where this is the first step after the redirect.
 */
        if (isRecommenderStep(getCurStep())) {

            const $jobList = $('.job-recommender-job-list');
            const recommenderType = $jobList.data('recommender-type');
            const recommenderWantsPromotedJobs = !!($jobList.data('recommender-wants-promoted-jobs') ?? 1);
            const recommenderWantsNonPromotedJobs = !!($jobList.data('recommender-wants-non-promoted-jobs') ?? 1);

            const recommenderControl = getRecommenderControlValue();
            const { wantsPromotedJobs, wantsNonPromotedJobs } = getRecommenderOverrides(
                recommenderControl,
                recommenderWantsPromotedJobs,
                recommenderWantsNonPromotedJobs,
            );

            const jobList = new JobList({
                source: recommenderInternalSource,
                recommenderType: recommenderType,
                funnelSlug: funnelSlug,
                sessionLimit: recommenderSessionLimit,
                wantsPromotedJobs: wantsPromotedJobs,
                wantsNonPromotedJobs: wantsNonPromotedJobs,
            });

            //Skip recommender step if recommender flag is off
            if (getRecommenderControlValue() === RECOMMENDER_OFF) {
                stepForwardOnRecommenderEvent();
            } else {
                jobList.init();
            }
        }

        $(document).on('job-recommender:profile-updated-from-override', function(e) {
            if (!e.detail?.overrides) {
                return;
            }

            const { specialty, license } = e.detail.overrides;

            if (specialty && $ovrSpecialtyField.length) {
                $ovrSpecialtyField.val(specialty);
            }

            if (license && $ovrLicenseField.length) {
                $ovrLicenseField.val(license);
            }
        });

        if (!overridePhoneValidationButtonDisable) {
            checkDuplicatePhone($phone, $first, $last);
        }
        if (!overrideEmailValidationButtonDisable) {
            checkDuplicateEmail($email);
        }

        if (getCurStep() === getTotalSteps()) {
            $(window).off('beforeunload');
        }

        /**
* The following few listeners are some serious jank. Select2 does not trigger actual DOM events properly
* apparently. So, this is a way to help manually trigger validation and add some bonus
* a11y to the funnel.
*
*/
        $(document).on('focus', '.select2-selection.select2-selection--single', function() {
            /**
* When someone tab-focuses on a select2 element, we will automatically focus and open the dropdown.
* When they focus _away_ from this element, blur will be triggered correctly.
*/
            $(this).closest('.select2-container').siblings('select:enabled').select2('open');
        });

        $(document).on('select2:close', '.select2-hidden-accessible', function() {
            /**
* Trigger a focusout event whenever the selec2 list of values is closed. This will let parsley
* pick up on the event and show an error if nothing was selected.
*/
            $(this).trigger('focusout');
        });

        $(document).on('focusout', '.select2-selection--multiple input.select2-search__field', function() {
            /**
* Select2 does not trigger focusout on the actual select element, when focus-out-ing.
* In this case, when the user tabs or clicks on select and is actually focused on the search input,
* We want to make sure that the focusout attributed to the search input also triggers focusout on the select element.
*/
            $(this).closest('.select2-container').siblings('select:enabled').trigger('focusout');
        });

        companyCount();

        if (new URLSearchParams(window.location.search).has('oops')) {
            prefillCurrentState();
        }

        $('button#verification_code__submit').on('one-time-code:verification:submit', () => {
            if (!isVerificationStep(getCurStep())) {
                return;
            }

            nextStep($('button#verification_code__submit'));
        });
        $(document).on('apply:next-step:validated', () => {
            if (!isVerificationStep(getCurStep())) {
                return;
            }

            $('input[id^="verification_code__digit"]').prop('readonly', true);
        });
        $(document).on('apply:next-step:validation-failed', () => {
            $('button#verification_code__submit').prop('disabled', false);
        });
        $(document).on('apply:request:error', (evt) => {
            if (!isVerificationStep(getCurStep())) {
                return;
            }

            $('button#verification_code__submit').prop('disabled', false);
            if (evt.detail.errors?.throttle) {
                $(window).off('beforeunload');
                window.location.href = verificationAttemptsExhaustedRoute;
            } else {
                $('input[id^="verification_code__digit"]').prop('readonly', false).val('');
                $('input[id^="verification_code__digit1"]').focus();
            }
        });
        $(document).on('click', '#verification_code__resend', () => $(window).off('beforeunload'));

        $(document).on('click', '#btn_duplicate_leads_help', () => {
            $(window).off('beforeunload');
            location.href = contactRoute;
        });

        AddMore.init();
        LicensesSearch.init();
        SpecialtiesSearch.init();
        OneTimeCodeVerification.init();
    }
});
